// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-28T08:17:12Z                      #

// ##############################################################

export function updateAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'AdresaVO',
    };


    return result;
}

export function updateMapAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateAdresa_CEF31D(data[key]);
    });
    return result;
}

export function updateListAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_CEF31D);
}

export function updateFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.fyzickaOsoba !== "undefined") {
        result.fyzickaOsoba = updateFyzickaOsoba_0D0EFC(data.fyzickaOsoba);
    }
    if (typeof data.pravniForma !== "undefined") {
        result.pravniForma = updatePravniForma_6646A5(data.pravniForma);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsobaPodVO_762C50(data[key]);
    });
    return result;
}

export function updateListFyzickaOsobaPodVO_762C50(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsobaPodVO_762C50);
}

export function updateDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'DokladVO',
    };


    return result;
}

export function updateMapDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateDoklad_0FE11E(data[key]);
    });
    return result;
}

export function updateListDoklad_0FE11E(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateDoklad_0FE11E);
}

export function updateKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }

    return result;
}

export function updateMapKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKontaktVO_081B44(data[key]);
    });
    return result;
}

export function updateListKontaktVO_081B44(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKontaktVO_081B44);
}

export function updateFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.identifikacniDoklad !== "undefined") {
        result.identifikacniDoklad = updateDoklad_0FE11E(data.identifikacniDoklad);
    }
    if (typeof data.cestovniDoklad !== "undefined") {
        result.cestovniDoklad = updateDoklad_0FE11E(data.cestovniDoklad);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsobaVO_687919(data[key]);
    });
    return result;
}

export function updateListFyzickaOsobaVO_687919(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsobaVO_687919);
}

export function updatePravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'PravniFormaVO',
    };


    return result;
}

export function updateMapPravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePravniForma_6646A5(data[key]);
    });
    return result;
}

export function updateListPravniForma_6646A5(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePravniForma_6646A5);
}

export function updateSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }

    if (!data["@class"]) {
        console.error("Objekt nemá definován typ třídy (atribut @class)", data);
        throw "Objekt nemá definován typ třídy (atribut @class)";
    }

    switch (data["@class"]) {
        case "FyzickaOsobaVO":
            return updateFyzickaOsobaVO_687919(data);
        case "PravnickaOsobaVO":
            return updatePravnickaOsobaVO_CE3CCC(data);
        case "FyzickaOsobaPodVO":
            return updateFyzickaOsobaPodVO_762C50(data);
        default:
            console.error("Nepodporovaný typ třídy (atribut @class)", data["@class"], data);
            throw "Nepodporovaný typ třídy (atribut @class) '" + data["@class"] + "'";
    }
}

export function updateMapSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSubjekt_62E626(data[key]);
    });
    return result;
}

export function updateListSubjekt_62E626(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSubjekt_62E626);
}

export function updateFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'FyzickaOsobaVO',
    };

    if (typeof data.identifikacniDoklad !== "undefined") {
        result.identifikacniDoklad = updateDoklad_0FE11E(data.identifikacniDoklad);
    }
    if (typeof data.cestovniDoklad !== "undefined") {
        result.cestovniDoklad = updateDoklad_0FE11E(data.cestovniDoklad);
    }

    return result;
}

export function updateMapFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFyzickaOsoba_0D0EFC(data[key]);
    });
    return result;
}

export function updateListFyzickaOsoba_0D0EFC(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFyzickaOsoba_0D0EFC);
}

export function updateKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'KontaktVO',
    };

    if (typeof data.adresa !== "undefined") {
        result.adresa = updateAdresa_CEF31D(data.adresa);
    }

    return result;
}

export function updateMapKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateKontakt_39A327(data[key]);
    });
    return result;
}

export function updateListKontakt_39A327(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateKontakt_39A327);
}

export function updatePravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.pravniForma !== "undefined") {
        result.pravniForma = updatePravniForma_6646A5(data.pravniForma);
    }
    if (typeof data.stavZr !== "undefined") {
        result.stavZr = updateSubjektStavZr_FDF5A9(data.stavZr);
    }
    if (typeof data.adresaTrv !== "undefined") {
        result.adresaTrv = updateAdresa_CEF31D(data.adresaTrv);
    }
    if (typeof data.adresaDoruc !== "undefined") {
        result.adresaDoruc = updateAdresa_CEF31D(data.adresaDoruc);
    }
    if (typeof data.email !== "undefined") {
        result.email = updateKontakt_39A327(data.email);
    }
    if (typeof data.telefon !== "undefined") {
        result.telefon = updateKontakt_39A327(data.telefon);
    }
    if (typeof data.datovaSchranka !== "undefined") {
        result.datovaSchranka = updateKontakt_39A327(data.datovaSchranka);
    }
    if (typeof data.zastupce !== "undefined") {
        result.zastupce = updateSubjekt_62E626(data.zastupce);
    }

    return result;
}

export function updateMapPravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updatePravnickaOsobaVO_CE3CCC(data[key]);
    });
    return result;
}

export function updateListPravnickaOsobaVO_CE3CCC(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePravnickaOsobaVO_CE3CCC);
}

export function updateSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'SubjektStavZrVO',
    };


    return result;
}

export function updateMapSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateSubjektStavZr_FDF5A9(data[key]);
    });
    return result;
}

export function updateListSubjektStavZr_FDF5A9(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateSubjektStavZr_FDF5A9);
}

export function updateZadostFilterVO_63E1B9(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
    };

    if (typeof data.drzitel !== "undefined") {
        result.drzitel = updateSubjekt_62E626(data.drzitel);
    }

    return result;
}

export function updateMapZadostFilterVO_63E1B9(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateZadostFilterVO_63E1B9(data[key]);
    });
    return result;
}

export function updateListZadostFilterVO_63E1B9(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateZadostFilterVO_63E1B9);
}
